import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { ThemeSettings } from "../../types/theme.js";
import { getLinkProps } from "../../client-utils/getLinkProps.js";
import { RichText } from "../../internal-components/rich-text/rich-text.js";

const Footer: React.FC = () => {
  const store = useStore<ThemeSettings>();
  const site = store.site;
  const menus = store.themeSettings.footerMenus || [];
  const text = store.themeSettings.footerText;

  return (
    <footer className="footer">
      <div className="main">
        <div className="menus container container-center hs">
          <div className="menu-block">
            <ul>
              <li>
                {site.logo && (
                  <img
                    src={transformImageUrl(site.logo, { height: 80 })}
                    alt={site.logo.altText || site.name}
                  />
                )}
              </li>
            </ul>
          </div>
          {menus.map((m, index) => {
            return (
              <div key={index} className="menu-block">
                {m.title && <h3 className="h6">{m.title}</h3>}

                <ul>
                  {(m.items || []).map((item, itemIndex) => {
                    if (!item.link) return null;

                    return (
                      <li key={itemIndex}>
                        <a {...getLinkProps(item.link)} className="b2">
                          {item.link.title || item.link.text}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <div className="bottom">
        {text && (
          <div className="container hs">
            <RichText html={text} />
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
